import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { MailChimpService } from '../../services/mailchimp.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-big-mailchimp-form',
  templateUrl: './big-mailchimp-form.component.html',
  styleUrls: ['./big-mailchimp-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BigMailChimpFormComponent {
  @Input() type = '';
  @Input() allBrands: string[] = [];

  @Output() submitForm = new EventEmitter<void>();

  phoneNumber = environment.data.contacts.filter(item => item.department === 'Sales')[0]['phone'];

  $error = new BehaviorSubject('');
  $success = new BehaviorSubject(false);

  constructor(private _mailChimpService: MailChimpService) {}

  reactiveForm: FormGroup = new FormGroup({
    fullName: new FormControl(null, Validators.required),
    phone: new FormControl(null),
    email: new FormControl(null, [Validators.required, Validators.email]),
    topic: new FormControl(null),
    message: new FormControl(null, Validators.required),
  });

  onSubmit() {
    this.$error.next('');
    const url='https://sitemule.us10.list-manage.com/subscribe/post-json?u=ef04a68a93992df3dca5cdd8f&amp;id=0fb3e9860c&amp;f_id=0047c8e5f0';
    const data = {
      'EMAIL': this.reactiveForm.value.email,
      'FNAME': this.reactiveForm.value.fullName,
      'PHONE': this.reactiveForm.value.phone,
      'TOPIC': this.reactiveForm.value.topic,
      'MESSAGE': this.reactiveForm.value.message,
    }
    this._mailChimpService.submitMailchimpForm(data, url).subscribe(response=>{
      if(response.success){
        this.$success.next(true);
        this.reactiveForm.reset();
        this.submitForm.emit();
      }
      else {
        this.$error.next(response.error || '');
      }
    });
  }
}
